import React from 'react';
import { Col, Container, Jumbotron, Row } from 'reactstrap';
import './about.css';

const About = () => (
  <section className='about'>
    <Jumbotron tag='section' className='text-center'>
      <Container>
        <h1>About</h1>
      </Container>
    </Jumbotron>
    <Container>
      <Row>
        <Col xs={12} md={{ offset: 1, size: 10 }}>
          <p>
            ZoukUnite brings together the best of zouk from around the world, providing info on:
          </p>
          <ul>
            <li>
              International &amp; national artists
            </li>
            <li>
              Major zouk congresses around the world
            </li>
            <li>
              Online options to learn zouk
            </li>
          </ul>
          <p>
            In future, we’ll also be adding studio locations for learning zouk, as well as details
            of smaller events and socials. We hope this website can be a useful resource for:
          </p>
          <ul>
            <li>
              Learning more about zouk and the artists who dance it
            </li>
            <li>
              Understanding when and where congresses are happening to help with your travel plans
            </li>
            <li>
              Event organisers to discover new artists and look at when may be best to host them and/or schedule events
            </li>
            <li>
              Reading about other dancers’ experiences (thanks to our guest bloggers!)
            </li>
          </ul>
          <p>
            Below are a few FAQs, we’re also always open to suggestions about how the site could be improved.
          </p>
        </Col>
      </Row>
      <div className='divider-new pt-5'>
        <h2 className='h2-responsive'>FAQs</h2>
      </div>
      <Row>
        <Col xs={12} md={{ offset: 1, size: 10 }}>
          <div className='faq'>
            <h4>Which artists are listed?</h4>
            <p>
              This list has been prepared by a few passionate Australian zouk dancers based on our knowledge of
              the artists we’ve come across, and the publicly available information we could find. We’ve focused
              on Leading International Artists first, but are also adding Emerging International Artists, Leading
              National Artists, and Emerging National Artists. No doubt there are other great artists we have
              missed! Please do let us know who else should be included so we can get them added.
            </p>
          </div>
          <div className='faq'>
            <h4>How have artists been categorised?</h4>
            <p>
              There are 4 categories of artist:
            </p>
            <ul>
              <li>Leading international zouk artist</li>
              <li>Emerging international zouk artist</li>
              <li>Leading national zouk artist</li>
              <li>Emerging national zouk artist</li>
            </ul>
            <p>
              Below is how we have defined each category to try and make it fair and clear. International doesn’t
              refer to being from Brazil (or elsewhere), but rather that the artist regularly teaches/performs in
              locations around the globe. We’re definitely open to feedback on whether there’s a better way to do
              this!
            </p>
            <h6>What makes a leading international zouk artist?</h6>
            <ul>
              <li>
                Dance is their full time profession and major source of income for at least the past 5 years
              </li>
              <li>
                They teach/perform at a minimum of 4 international zouk congresses (outside their home base) each year
              </li>
              <li>
                They have achieved prominence and name recognition globally
              </li>
              <li>
                They have a strong following on social media
              </li>
            </ul>
            <h6>What makes an emerging international zouk artist?</h6>
            <ul>
              <li>
                Dance is their profession and significant source of income for at least the past 3 years
              </li>
              <li>
                They teach/perform at a minimum of 2 international zouk congresses (outside their home base) each year
              </li>
              <li>
                They are developing prominence and name recognition globally
              </li>
              <li>
                They are developing their following on social media
              </li>
            </ul>
            <h6>What makes a leading national zouk artist?</h6>
            <ul>
              <li>
                Dance is their full time profession and major source of income for at least the past 5 years
              </li>
              <li>
                They teach/perform at a minimum of 4 zouk congresses each year
              </li>
              <li>
                They have achieved prominence and name recognition nationally
              </li>
              <li>
                They have a strong following on social media
              </li>
            </ul>
            <h6>What makes an emerging national zouk artist?</h6>
            <ul>
              <li>
                Dance is their profession and significant source of income for at least the past 3 years
              </li>
              <li>
                They teach/perform at a minimum of 2 national zouk congresses each year
              </li>
              <li>
                They are developing prominence and name recognition nationally
              </li>
              <li>
                They are developing their following on social media
              </li>
            </ul>
          </div>
          <div className='faq'>
            <h4>What if an artist is missing or their details are incorrect?</h4>
            <p>
              Please get in touch with the artists details. The more detail you can provide (including how they
              meet the criteria for the relevant category), the quicker it will be to get your suggestion processed.
            </p>
          </div>
          <div className='faq'>
            <h4>How can an artist claim their profile?</h4>
            <p>
              We are working on a management system to allow artists to maintain their own profile. If you’re an
              artist who would like to make use of this, please do let us know so we can notify you when it’s ready.
            </p>
          </div>
          <div className='faq'>
            <h4>Which events are listed?</h4>
            <p>
              At this stage, ZoukUnite is focused on listing major international zouk congresses, and key major
              international dance congresses that include zouk artists and a dedicated zouk party room. We do
              plan to broaden this in future to include smaller events and opportunities for social dancing (still
              with a focus on zouk of course!).
            </p>
          </div>
          <div className='faq'>
            <h4>What if an event is missing or incorrect?</h4>
            <p>
              Please get in touch with the event details. The more detail you can provide (including links to the
              website and/or facebook page), the quicker it will be to get your suggestion processed.
            </p>
          </div>
          <div className='faq'>
            <h4>How can an organiser maintain their own events?</h4>
            <p>
              We are working on a management system to allow organisers to maintain their own events. If you’re
              an organiser who would like to make use of this, please do let us know so we can notify you when
              it’s ready.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  </section>
);

export default About;



// WEBPACK FOOTER //
// ./src/components/pages/app/about/about.js